import { Clock, Zap, LogOut, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LOGO_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_battery-stock-hub/artifacts/1cicyv9h_GREENRGY%20NEW%20FINAL%20LOGO.webp";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const rejected = user?.status === "rejected";

  return (
    <div className="min-h-screen bg-[#F5F5F4] flex items-center justify-center p-6" data-testid="pending-page">
      <div className="max-w-lg w-full bg-white border border-zinc-200 p-10 text-center">
        <img src={LOGO_URL} alt="GREENRGY" className="h-12 mx-auto mb-8" />

        <div className={`w-16 h-16 mx-auto mb-6 flex items-center justify-center border ${rejected ? "border-[#DC2626] bg-[#DC2626]/10" : "border-[#D97706] bg-[#D97706]/10"}`}>
          {rejected ? <XCircle className="w-8 h-8 text-[#DC2626]" /> : <Clock className="w-8 h-8 text-[#D97706]" />}
        </div>

        <div className="overline mb-2">Account Status</div>
        <h1 className="font-display text-3xl uppercase text-zinc-900 mb-4">
          {rejected ? "Access Denied" : "Awaiting Approval"}
        </h1>

        <p className="text-zinc-600 mb-2">
          Hi <span className="font-semibold text-zinc-900">{user?.name}</span>,
        </p>
        <p className="text-zinc-600 mb-6 leading-relaxed">
          {rejected
            ? "Your account request was declined by the administrator. If you believe this is a mistake, please contact your GREENRGY admin."
            : "Your account has been received and is waiting for an administrator to approve access. You will be granted entry the moment an admin approves you."}
        </p>

        <div className="border border-zinc-200 bg-zinc-50 p-4 mb-6 text-left">
          <div className="overline mb-1">Signed in as</div>
          <div className="text-sm text-zinc-900 font-semibold">{user?.email}</div>
          <div className="text-xs text-zinc-500 mt-1 font-mono uppercase tracking-widest">
            Role: {user?.role} · Status: {user?.status}
          </div>
        </div>

        <button
          onClick={logout}
          data-testid="pending-logout-btn"
          className="btn-ghost w-full flex items-center justify-center gap-2"
        >
          <LogOut className="w-4 h-4" /> Sign Out
        </button>

        <div className="mt-8 text-xs text-zinc-400 uppercase tracking-widest flex items-center justify-center gap-2">
          <Zap className="w-3 h-3 text-[#16A34A]" />
          GREENRGY Battery OS
        </div>
      </div>
    </div>
  );
}
